import { render, staticRenderFns } from "./userGroupCreateChat.vue?vue&type=template&id=1deff49a&scoped=true&"
import script from "./userGroupCreateChat.vue?vue&type=script&lang=ts&"
export * from "./userGroupCreateChat.vue?vue&type=script&lang=ts&"
import style0 from "./userGroupCreateChat.vue?vue&type=style&index=0&id=1deff49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deff49a",
  null
  
)

export default component.exports